import request from "../request";


// Add Category
export const addCategory = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post("category/", data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Edit Category Details By Id
export const editCategoryDetailsById = (id, body) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`category/` + id, body)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Get Category List
export const getCategoryList = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/category`, { params: data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Get Category Details By Id
export const getCategoryDetailsById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`category/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Delete Category Details By Id
export const deleteCategory = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`category/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

